import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@material-ui/core';
// see https://material-ui.com/components/material-icons/
import { Info as InfoIcon } from '@material-ui/icons';

import { AmContainerLeft } from '../../controls/';

// NOTE: Copy generated by:

const PrivacyPolicy = () => {
  // TODO: Move this to a config file.
  const site = 'app.actionsmatter.net';
  // TODO: Move this to a config file.
  const companyName = 'Actions Matter';
  const companyEmail = 'info@actionsmatter.net';

  return (
    <div>
      <InfoIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        Privacy Policy
      </Typography>
      <Typography variant="body1" component="h1" color="textSecondary">
        Actions Matter Privacy Policy
      </Typography>
      <Typography variant="body2" component="h1" color="textSecondary">
        Last updated: August 15, 2020
      </Typography>

      <AmContainerLeft>
        <Typography variant="body2" component="h1" color="textSecondary">
          This Privacy Policy describes Our policies and procedures on the
          collection, use and disclosure of Your information when You use the
          Service and tells You about Your privacy rights and how the law
          protects You. We use Your Personal data to provide and improve the
          Service. By using the Service, You agree to the collection and use of
          information in accordance with this Privacy Policy.
        </Typography>

        <Typography variant="h5" component="h1" color="textSecondary">
          Interpretation and Definitions
        </Typography>
        <Typography variant="h6" component="h1" color="textSecondary">
          Interpretation
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The words of which the initial letter is capitalized have meanings
          defined under the following conditions.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The following definitions shall have the same meaning regardless of
          whether they appear in singular or in plural.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Definitions
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          For the purposes of this Privacy Policy:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              You means the individual accessing or using the Service, or the
              company, or other legal entity on behalf of which such individual
              is accessing or using the Service, as applicable.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Company (referred to as either "the Company", "We", "Us" or "Our"
              in this Agreement) refers to {companyName}.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Affiliate means an entity that controls, is controlled by or is
              under common control with a party, where "control" means ownership
              of 50% or more of the shares, equity interest or other securities
              entitled to vote for election of directors or other managing
              authority.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Account means a unique account created for You to access our
              Service or parts of our Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Website refers to {companyName}, accessible from {site}.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Service refers to the Website.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Country refers to: California, United States
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Service Provider means any natural or legal person who processes
              the data on behalf of the Company. It refers to third-party
              companies or individuals employed by the Company to facilitate the
              Service, to provide the Service on behalf of the Company, to
              perform services related to the Service or to assist the Company
              in analyzing how the Service is used.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Third-party Social Media Service refers to any website or any
              social network website through which a User can log in or create
              an account to use the Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Personal Data is any information that relates to an identified or
              identifiable individual.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Cookies are small files that are placed on Your computer, mobile
              device or any other device by a website, containing the details of
              Your browsing history on that website among its many uses.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Device means any device that can access the Service such as a
              computer, a cellphone or a digital tablet.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Usage Data refers to data collected automatically, either
              generated by the use of the Service or from the Service
              infrastructure itself (for example, the duration of a page visit).
            </Typography>
          </li>
        </ul>

        <Typography variant="h5" component="h1" color="textSecondary">
          Collecting and Using Your Personal Data
        </Typography>
        <Typography variant="h6" component="h1" color="textSecondary">
          Types of Data Collected
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          While using Our Service, We may ask You to provide Us with certain
          personally identifiable information that can be used to contact or
          identify You. Personally identifiable information may include, but is
          not limited to:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Email address
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              First name and last name
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              {' '}
              Usage Data
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" component="h1" color="textSecondary">
          Usage Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Usage Data is collected automatically when using the Service.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Usage Data may include information such as the pages of our Service
          that You visit, the time and date of Your visit, the time spent on
          those pages, unique device identifiers and other diagnostic data.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We may also collect information that Your browser sends whenever You
          visit our Service or when You access the Service by or through a
          mobile device.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Tracking Technologies and Cookies
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We use Cookies and similar tracking technologies to track the activity
          on Our Service and store certain information. Tracking technologies
          used are beacons, tags, and scripts to collect and track information
          and to improve and analyze Our Service.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          You can instruct Your browser to refuse all Cookies or to indicate
          when a Cookie is being sent. However, if You do not accept Cookies,
          You may not be able to use some parts of our Service.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
          remain on your personal computer or mobile device when You go offline,
          while Session Cookies are deleted as soon as You close your web
          browser. Learn more about cookies here:
        </Typography>
        <Link href="https://en.wikipedia.org/wiki/HTTP_cookie" variant="body2">
          Cookies: What Do They Do?
        </Link>

        <Typography variant="body2" component="h1" color="textSecondary">
          We use both session and persistent Cookies for the purposes set out
          below:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Necessary / Essential Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Type: Session Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Administered by: Us
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Purpose: These Cookies are essential to provide You with services
              available through the Website and to enable You to use some of its
              features. They help to authenticate users and prevent fraudulent
              use of user accounts. Without these Cookies, the services that You
              have asked for cannot be provided, and We only use these Cookies
              to provide You with those services.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Cookies Policy / Notice Acceptance Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Type: Persistent Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Administered by: Us
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Purpose: These Cookies identify if users have accepted the use of
              cookies on the Website.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Functionality Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Type: Persistent Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Administered by: Us
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Purpose: These Cookies allow us to remember choices You make when
              You use the Website, such as remembering your login details or
              language preference. The purpose of these Cookies is to provide
              You with a more personal experience and to avoid You having to
              re-enter your preferences every time You use the Website.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Tracking and Performance Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Type: Persistent Cookies
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Administered by: Third-Parties
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Purpose: These Cookies are used to track information about traffic
              to the Website and how users use the Website. The information
              gathered via these Cookies may directly or indirectly identify you
              as an individual visitor. This is because the information
              collected is typically linked to a pseudonymous identifier
              associated with the device you use to access the Website. We may
              also use these Cookies to test new pages, features or new
              functionality of the Website to see how our users react to them.
            </Typography>
          </li>
        </ul>
        <Typography variant="body2" component="h1" color="textSecondary">
          For more information about the cookies we use and your choices
          regarding cookies, please visit our Cookies Policy.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Use of Your Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The Company may use Personal Data for the following purposes:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              To provide and maintain our Service, including to monitor the
              usage of our Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              To manage Your Account: to manage Your registration as a user of
              the Service. The Personal Data You provide can give You access to
              different functionalities of the Service that are available to You
              as a registered user.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              For the performance of a contract: the development, compliance and
              undertaking of the purchase contract for the products, items or
              services You have purchased or of any other contract with Us
              through the Service.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              To contact You: The company will NEVER contact You by email,
              telephone calls, SMS, or other equivalent forms of electronic
              communication, such as a mobile application's push notifications
              regarding updates or informative communications related to the
              functionalities, products or contracted services, including the
              security updates, when necessary or reasonable for their
              implementation unless You explicity opt-in.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              The Company will NEVER use your email address to provide You with
              news, special offers and general information about other goods,
              services and events which we offer that are similar to those that
              you have already purchased or enquired about unless You have opted
              not to receive such information.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              To manage Your requests: To attend and manage Your requests to Us.
            </Typography>
          </li>
        </ul>

        <Typography variant="body2" component="h1" color="textSecondary">
          We may share your personal information in the following situations:
        </Typography>

        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              With Service Providers: We may share Your personal information
              with Service Providers to monitor and analyze the use of our
              Service, but NEVER to contact You.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              For Business transfers: We may share or transfer Your personal
              information in connection with, or during negotiations of, any
              merger, sale of Company assets, financing, or acquisition of all
              or a portion of our business to another company.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              With Affiliates: We may share Your information with Our
              affiliates, in which case we will require those affiliates to
              honor this Privacy Policy. Affiliates include Our parent company
              and any other subsidiaries, joint venture partners or other
              companies that We control or that are under common control with
              Us.
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              With other users: when You share personal information or otherwise
              interact in the public areas with other users, such information
              may be viewed by all users and may be publicly distributed
              outside. If You interact with other users or register through a
              Third-Party Social Media Service, Your contacts on the Third-Party
              Social Media Service may see You name, profile, pictures and
              description of Your activity. Similarly, other users will be able
              to view descriptions of Your activity, communicate with You and
              view Your profile.
            </Typography>
          </li>
        </ul>

        <Typography variant="body2" component="h1" color="textSecondary">
          We would NEVER share your personal information in the following
          situations:
        </Typography>

        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              With Business partners: We will NEVER share Your information with
              Our business partners to offer You certain products, services or
              promotions.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" component="h1" color="textSecondary">
          Retention of Your Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The Company will retain Your Personal Data only for as long as is
          necessary for the purposes set out in this Privacy Policy. We will
          retain and use Your Personal Data to the extent necessary to comply
          with our legal obligations (for example, if we are required to retain
          your data to comply with applicable laws), resolve disputes, and
          enforce our legal agreements and policies.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The Company will also retain Usage Data for internal analysis
          purposes. Usage Data is generally retained for a shorter period of
          time, except when this data is used to strengthen the security or to
          improve the functionality of Our Service, or We are legally obligated
          to retain this data for longer time periods.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Transfer of Your Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Your information, including Personal Data, is processed at the
          Company's operating offices and in any other places where the parties
          involved in the processing are located. It means that this information
          may be transferred to — and maintained on — computers located outside
          of Your state, province, country or other governmental jurisdiction
          where the data protection laws may differ than those from Your
          jurisdiction.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Your consent to this Privacy Policy followed by Your submission of
          such information represents Your agreement to that transfer.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The Company will take all steps reasonably necessary to ensure that
          Your data is treated securely and in accordance with this Privacy
          Policy and no transfer of Your Personal Data will take place to an
          organization or a country unless there are adequate controls in place
          including the security of Your data and other personal information.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Disclosure of Your Personal Data
        </Typography>
        <Typography variant="h6" component="h1" color="textSecondary">
          Business Transactions
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          If the Company is involved in a merger, acquisition or asset sale,
          Your Personal Data may be transferred. We will provide notice before
          Your Personal Data is transferred and becomes subject to a different
          Privacy Policy.
        </Typography>
        <Typography variant="h6" component="h1" color="textSecondary">
          Law enforcement
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Under certain circumstances, the Company may be required to disclose
          Your Personal Data if required to do so by law or in response to valid
          requests by public authorities (e.g. a court or a government agency).
        </Typography>
        <Typography variant="h6" component="h1" color="textSecondary">
          Other legal requirements
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The Company may disclose Your Personal Data in the good faith belief
          that such action is necessary to:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Comply with a legal obligation
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Protect and defend the rights or property of the Company
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Prevent or investigate possible wrongdoing in connection with the
              Service
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Protect the personal safety of Users of the Service or the public
            </Typography>
          </li>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Protect against legal liability
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" component="h1" color="textSecondary">
          Security of Your Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          The security of Your Personal Data is important to Us, but remember
          that no method of transmission over the Internet, or method of
          electronic storage is 100% secure. While We strive to use commercially
          acceptable means to protect Your Personal Data, We cannot guarantee
          its absolute security.
        </Typography>

        <Typography variant="h5" component="h1" color="textSecondary">
          Detailed Information on the Processing of Your Personal Data
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Service Providers have access to Your Personal Data only to perform
          their tasks on Our behalf and are obligated not to disclose or use it
          for any other purpose.
        </Typography>

        <Typography variant="h6" component="h1" color="textSecondary">
          Analytics
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We may use third-party Service providers to monitor and analyze the
          use of our Service.
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              Segment
            </Typography>
            <Typography variant="body2" component="h1" color="textSecondary">
              Segment is provided by Segment Inc.
            </Typography>
          </li>
        </ul>

        <Typography variant="h5" component="h1" color="textSecondary">
          Children's Privacy
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Our Service does not address anyone under the age of 13. We do not
          knowingly collect personally identifiable information from anyone
          under the age of 13. If You are a parent or guardian and You are aware
          that Your child has provided Us with Personal Data, please contact Us.
          If We become aware that We have collected Personal Data from anyone
          under the age of 13 without verification of parental consent, We take
          steps to remove that information from Our servers.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          If We need to rely on consent as a legal basis for processing Your
          information and Your country requires consent from a parent, We may
          require Your parent's consent before We collect and use that
          information.
        </Typography>

        <Typography variant="h5" component="h1" color="textSecondary">
          Links to Other Websites
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          Our Service may contain links to other websites that are not operated
          by Us. If You click on a third party link, You will be directed to
          that third party's site. We strongly advise You to review the Privacy
          Policy of every site You visit.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We have no control over and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </Typography>

        <Typography variant="h5" component="h1" color="textSecondary">
          Changes to this Privacy Policy
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We may update our Privacy Policy from time to time. We will notify You
          of any changes by posting the new Privacy Policy on this page.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          We will let You know via email and/or a prominent notice on Our
          Service, prior to the change becoming effective and update the "Last
          updated" date at the top of this Privacy Policy.
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          You are advised to review this Privacy Policy periodically for any
          changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </Typography>

        <Typography variant="h5" component="h1" color="textSecondary">
          Contact Us
        </Typography>
        <Typography variant="body2" component="h1" color="textSecondary">
          If you have any questions about this Privacy Policy, You can contact
          us:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2" component="h1" color="textSecondary">
              By email: {companyEmail}
            </Typography>
          </li>
        </ul>
      </AmContainerLeft>

      <Link component={RouterLink} to="/" variant="body2">
        {'Return home'}
      </Link>
    </div>
  );
};

export { PrivacyPolicy };
